(function(){
    const header = document.querySelector('.section-header');
    const logo = document.querySelector('.header__heading-logo-wrapper');
    window.addEventListener('scroll', () => {
        if(window.scrollY >= 700){
            header.classList.add('add-bg');
            logo.classList.remove('hide');
        }else{
            header.classList.remove('add-bg');
            logo.classList.add('hide');
        }
    })
})()